import { useEffect, useState } from "react";
import useSinglePart from "../../data/useSinglePart";
import { IPart, IPartMarketplaces } from "../../models/Part";
import Card from "../shared/Card/Card";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import SwitchInput from "../shared/Inputs/SwitchInput";
import LoadingWheel from "../shared/LoadingWheel";
import { useForm } from "react-hook-form";
import { set } from "lodash";
import useSettings from "../../data/useSettings";


export default function PartMarketplaces({ part }: { part: IPart }) {
  const { register, handleSubmit, watch, setValue, reset } = useForm<IPartMarketplaces>();

  const { marketplaces, updateMarketplaces } = useSinglePart(part.id);
  const { loading, settings } = useSettings();

  const [listEbay, setListEbay] = useState(true);
  const [listPartPro, setListPartPro] = useState(false);
  const [listShopify, setListShopify] = useState(false);

  useEffect(() => {
    if (marketplaces.isLoading) return;
    if (!marketplaces.data?.data) return;

    reset({
      id: marketplaces.data.data.id,
      ebay: marketplaces.data.data.ebay,
      partPro: false,//marketplaces.data.data.partPro,
      shopify: marketplaces.data.data.shopify,
    });

    // setValue("id"     , marketplaces.data.data.id     );
    // setValue("ebay"   , marketplaces.data.data.ebay   );
    // setValue("partPro", marketplaces.data.data.partPro);
    // setValue("shopify", marketplaces.data.data.shopify);
  }, [marketplaces.data, marketplaces.isLoading]);

  useEffect(() => {
    if (!loading && settings.length > 0) {
      const partProSetting = settings.find(s => s.key === "PartPro:EnableMarketplace");
      const shopifySetting = settings.find(s => s.key === "Shopify:EnableMarketplace");

      setListPartPro(partProSetting ? partProSetting.value === "true" : false);
      setListShopify(shopifySetting ? shopifySetting.value === "true" : false);
    }

  }, [settings]);

  const onSubmit = (data: IPartMarketplaces) => {
    updateMarketplaces.mutate(data);
  }

  return (
    <Card title="Marketplaces" bodyClassName="px-6 py-5">
      {
        marketplaces.isLoading ?
          <LoadingWheel /> :
          <>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <SwitchInput label="Ebay" register={register} registerName={"ebay"} watch={watch} setValue={setValue} groupClasses="!justify-between" />
              {listPartPro && (
                <SwitchInput label="Part Pro" register={register} registerName={"partPro"} watch={watch} setValue={setValue} groupClasses="!justify-between" />
              )}
              {listShopify && (
                <SwitchInput label="Shopify" register={register} registerName={"shopify"} watch={watch} setValue={setValue} groupClasses="!justify-between" />
              )}

              <ButtonInput isSubmit={true} label="Save" classes="mt-10" onClick={() => { }} />
            </form>
          </>
      }
    </Card>
  );
};